(window.bwProgressBar = function ($, Behaviors) {
    "use strict";

    const module = {};

    function bwProgressBar() {
        const progressBar = document.getElementById("bw-progress-bar-holder");

        if (!progressBar) {return;}

        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;
        progressBar.querySelector('span').style.width = scrolled + "%";
    }

    window.onscroll = () => {bwProgressBar()};

    //ugly solution to make fixed header appear when page is reloaded in the middle of page height
    window.onload = () => {
        window.scrollBy(0, -1);
    }


    document.addEventListener('DOMContentLoaded', () => {
        bwProgressBar();
    });

    return module;

}(window.jQuery, window.Behaviors));

